<template>
  <CoreButton
    class="eating-day-btn"
    w100
    :type="buttonType"
    @click="selectMealDay"
  >
    <div>
      <div class="eating-day-btn__days-count">
        {{ numberOfMealDays }}
      </div>
      <div
        class="eating-day-btn__days-text"
        :class="daysTextClasses"
      >
        {{ daysText }}
      </div>
    </div>
    <div
      v-if="isDiscountVisible"
      class="eating-day-btn__discount"
    >
      {{ discount }}
      <sprite
        v-if="mealDaysGift"
        class="eating-day-btn__gift"
        src="sprites_gift"
      />
    </div>
    <div
      v-if="cashback"
      class="eating-day-btn__discount eating-day-btn__discount--cashback"
    >
      {{ cashback }}
    </div>
  </CoreButton>
</template>

<script>
import CoreButton from '@/components/core/ui/CoreButton'
// constants
import { CosmeticDiscount, CAHBACK_VISIBLE_THRESHOLD } from '@/config/constants'
import { mapGetters } from 'vuex'

export default {
  name: 'EatingDayButton',

  components: {
    CoreButton,
  },

  props: {
    mealDay: {
      type: Object,
      required: true,
    },

    selectedMealDay: {
      type: [Object, null],
      required: true,
    },
  },

  emits: ['select'],

  computed: {
    ...mapGetters('marketing', ['isCosmeticDiscountVisible']),

    isDiscountVisible () {
      return this.discount && !this.cashback
    },

    discount () {
      if (this.isCosmeticDiscountVisible) {
        return `-${CosmeticDiscount[this.mealDay.subscriptionDays || this.mealDay.numberOfMealDays]}%`
      }

      if (this.mealDay.promoInfo.benefit === 0) {
        return null
      }

      const benefitBubbleByType = {
        absolute: `-${this.mealDay.promoInfo.benefit}₽`,
        percent: `-${this.mealDay.promoInfo.benefitPercent}%`,
        mealdays: () => `+${this.$numberLingFormWithNumberFunc(this.mealDaysGift?.discountValue, 'день', 'дня', 'дней')}`,
      }

      return benefitBubbleByType[this.mealDay.promoInfo.mobBenefitBubbleType]
    },
    cashback () {
      const cashbackInfo = this.mealDay.promoInfo?.benefitValues.find(
        value => value.benefitType === 'cashback_percent_base',
      )
      let cashback
      if (cashbackInfo && (cashbackInfo?.value * 100 / this.mealDay.fullPrice) > CAHBACK_VISIBLE_THRESHOLD) {
        cashback = cashbackInfo?.name
      }
      return cashback
    },

    mealDaysGift () {
      return this.mealDay.promoInfo?.discounts.find(
        value => value.discountType === 'mealdays',
      )
    },

    numberOfMealDays () {
      return this.mealDay.subscriptionDays || this.mealDay.numberOfMealDays
    },

    daysText () {
      return this.$numberLingFormWithNumberFunc(this.numberOfMealDays, 'день', 'дня', 'дней', null, true)
    },

    isActive () {
      return this.mealDay.title === this.selectedMealDay?.title
    },

    daysTextClasses () {
      return {
        'eating-day-btn__days-text--white': this.isActive,
      }
    },

    buttonType () {
      if (this.isActive) {
        return 'from-var'
      }
      return 'white-grey'
    },
  },

  methods: {
    selectMealDay () {
      this.$emit('select', this.mealDay)
    },
  },
}
</script>

<style lang="scss">
.eating-day-btn {
  min-height: 48px;
  border-radius: 16px;
  font-size: 12px;
  line-height: 14px;
  padding: 0;
  text-transform: none;
  position: relative;

  &__days-count {
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
  }

  &__days-text {
    color: map-get($colors, 'grey_40');

    &--white {
      color:  var(--color, map-get($colors, 'white'));
    }
  }

  &__discount {
    position: absolute;
    right: -7px;
    top: -8px;
    background-color: map-get($colors, 'red');
    padding: 4px 6px;
    font-size: 8px;
    font-weight: 500;
    line-height: 8px;
    color: map-get($colors, 'white');
    border-radius: 8px;
    text-transform: uppercase;
    white-space: nowrap;
    &--cashback {
      background: linear-gradient(133.73deg, #638FFF -1.69%, #8962F8 97.05%);
    }
  }

  &__gift {
    &.c-icon {
      width: 7px;
      height: 7px;
      margin-left: 2px;
    }
  }
}
</style>
